import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import {Dialogue, Modal, Text, Button, Anchor} from '@albert-io/atomic';

const EmptyFolderModal = ({toggleEmptyFolderModal}) => {
  return (
    <Modal ariaLabel='Cancel rerranging warning modal' handleClose={toggleEmptyFolderModal}>
      {({modalContentStyle}) => {
        return (
          <Dialogue
            paddingLevel={3}
            size='s'
            handleClose={toggleEmptyFolderModal}
            className={modalContentStyle}
          >
            <Dialogue.Title stretchTitle align='center'>
              Folder is empty
            </Dialogue.Title>
            <Dialogue.Body align='center'>
              <Text>Get started by adding questions from our subject library.</Text>
            </Dialogue.Body>
            <Dialogue.BtnGroup fillColumn direction='column' align='center'>
              <Button as={Link} to='/subjects/discover'>
                Go to subject library
              </Button>
              <Text className='u-text-align_center' as='p'>
                <Anchor
                  as='a'
                  className='u-text-align_center'
                  href='https://help.albert.io/en/articles/2829365-how-do-i-assign-a-folder'
                  underlined
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Learn more about assigning a folder
                </Anchor>
              </Text>
            </Dialogue.BtnGroup>
          </Dialogue>
        );
      }}
    </Modal>
  );
};

EmptyFolderModal.propTypes = {
  toggleEmptyFolderModal: PropTypes.func
};

export default EmptyFolderModal;
